export default "__VITE_ASSET__CyV_lBuf__"